import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import whatappIcon from "../image/whatsapp.svg";
import Ellipsefoot from "../image/icons/Ellipsefoot.png";
import { ReactComponent as GetTouch } from "../image/icons/getTouch.svg";
import { HttpPost } from "../helper/Api";
import { toast } from "react-hot-toast";
function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [emailId, setEmailId] = useState("");
  const handleSubscribe = async () => {
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (regex.test(emailId)) {
      const body = {
        EMAIL_ID: emailId,
      };
      const res = await HttpPost("SubscribeNewLetter", body);
      if (res.success) {
        toast.success("Subscribed successfully.");
        setEmailId("");
      }
    } else {
      toast.error("Please enter valid email.");
    }
  };
  return (
    <div
      className="footer-main"
      style={{
        backgroundImage: `url(${Ellipsefoot})`,
        backgroundSize: "100% 100%",
      }}
    >
      <div className="container">
        <div className="row align-items-start">
          <div className="col-md" style={{ textAlign: "left" }}>
            <div className="footer-add1" style={{ paddingBottom: '0px' }}>
              <div
                style={{
                  // paddingBottom: "10px",
                  fontSize: "13px",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  cursor: "pointer",
                  display: "flex",
                  direction: "row",
                  gap: "8px",
                }}
                onClick={() => navigate(`/contact-us/`)}
              >
                <GetTouch />
                <p>Visit Our Store</p>
              </div>
            </div>
            <div className="footer-add2" style={{ paddingBottom: '12px' }}>
              <p style={{ padding: '0px', lineHeight: '10px' }}>Baijnath Jewellers</p>
              <p style={{ padding: '0px', lineHeight: '10px', marginBottom: "2px" }}>27-28A, PPN Market, Kanpur.</p>
              <p style={{ padding: '0px', lineHeight: '10px', marginBottom: "8px" }}>
                <a href="https://www.google.com/maps/search/?api=1&query=26.4746139,80.3429718" target="_blank" style={{ color: "blue", padding: "0px" }}>
                  <u>
                    Get Direction
                  </u>
                </a>
              </p>
              <p style={{ padding: '0px', lineHeight: '10px' }}>+91 9984500051/52</p>
            </div>
            <div className="footer-add2" style={{ paddingBottom: '12px' }}>
              <p style={{ padding: '0px', lineHeight: '10px' }}>Viya by Baijnath</p>
              <p style={{ padding: '0px', lineHeight: '10px' }}>7/145, Swaroop Nagar,</p>
              <p style={{ padding: '0px', lineHeight: '10px' , marginBottom: "2px"}}>The Chat Chauraha, Kanpur.</p>
              <p style={{ padding: '0px', lineHeight: '10px', marginBottom: "8px" }}>
                <a href="https://www.google.com/maps/search/?api=1&query=26.4833363,80.3169987" target="_blank" style={{ color: "blue", padding: "0px" }}>
                  <u>
                    Get Direction
                  </u>
                </a>
              </p>
              <p style={{ padding: '0px', lineHeight: '10px' }}>+91 8114007301/02</p>
            </div>
            <div className="footer-add2" style={{ paddingBottom: '12px' }}>
              <p style={{ padding: '0px', lineHeight: '10px' }}>Aaina Silver Jewellery by Baijnath</p>
              <p style={{ padding: '0px', lineHeight: '10px' }}>7/145, Swaroop Nagar,</p>
              <p style={{ padding: '0px', lineHeight: '10px', marginBottom: "2px" }}>The Chat Chauraha, Kanpur.</p>
              <p style={{ padding: '0px', lineHeight: '10px', marginBottom: "8px" }}>
                <a href="https://www.google.com/maps/search/?api=1&query=26.4833443,80.3170565" target="_blank" style={{ color: "blue", padding: "0px" }}>
                  <u>
                    Get Direction
                  </u>
                </a>
              </p>
              <p style={{ padding: '0px', lineHeight: '10px' }}>+91 8114007303/04</p>
            </div>
          </div>
          <div className="col-md" style={{ textAlign: "left" }}>
            <h5
              style={{
                paddingBottom: "20px",
                fontSize: "13px",
                fontFamily: "Poppins",
                fontWeight: 500,
              }}
            >
              JEWELLERY GUIDES
            </h5>
            <div className="jwel-guides">
              <p>
                <a
                  onClick={() => navigate(`/diamond-guide/`)}
                  href="#"
                  rel="noreferrer"
                >
                  Diamond Guide
                </a>
              </p>
              <p>
                <a
                  onClick={() => navigate(`/gemstone-guide/`)}
                  href="#"
                  rel="noreferrer"
                >
                  Gemstone Guide
                </a>
              </p>
              <p>
                <a
                  onClick={() =>
                    navigate(`/jewellery-guide/`)
                  }
                  href="#"
                  rel="noreferrer"
                >
                  Jewellery Guide
                </a>
              </p>
              <p>
                <a
                  href="https://files.synergicserp.com/BAIJNATH/FILES/Ring-size-Guide.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Ring Size
                </a>
              </p>
              <p>
                <a
                  href="https://files.synergicserp.com/BAIJNATH/FILES/Bangle-size-Guide.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Bangle Size
                </a>
              </p>
            </div>
          </div>
          <div className="col-md" style={{ textAlign: "left" }}>
            <h5
              style={{
                paddingBottom: "20px",
                fontSize: "13px",
                fontFamily: "Poppins",
                fontWeight: 500,
              }}
            >
              POLICIES
            </h5>
            <div className="jwel-policis">
              <p>
                <a
                  href="#"
                  onClick={() => navigate(`/faq-page/`)}
                  rel="noreferrer"
                >
                  FAQ
                </a>
              </p>
              <p>
                <a
                  href="#"
                  onClick={() => navigate(`/privacy-policy/`)}
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </p>
              <p>
                <a
                  href="#"
                  onClick={() =>
                    navigate(`/terms-conditions/`)
                  }
                  rel="noreferrer"
                >
                  Terms & Conditions
                </a>
              </p>
              <p>
                <a
                  href="#"
                  onClick={() =>
                    navigate(`/shipping-refund-policy/`)
                  }
                  rel="noreferrer"
                >
                  Shipping & Refund Policy
                </a>
              </p>
            </div>
          </div>
          <div className="col-md" style={{ textAlign: "left" }}>
            <div style={{ paddingBottom: "20px" }}>
              <input
                type="email"
                value={emailId}
                placeholder="Enter email for newsletter"
                id="input-footer"
                style={{
                  borderRadius: "0px",
                  height: "40px",
                  width: "100%",
                  textAlign: "left",
                  paddingLeft: "12px",
                }}
                onChange={(e) => setEmailId(e.target.value)}
              />
            </div>
            <div style={{ paddingBottom: "20px" }}>
              {" "}
              <button
                id="foot-sub"
                style={{ width: "100%" }}
                onClick={() => handleSubscribe()}
              >
                SUBSCRIBE
              </button>
            </div>
            <div style={{ paddingBottom: "20px" }}>
              <div>FOLLOW US ON</div>
              <p>
                <a
                  className="social-media"
                  href="https://www.facebook.com"
                  target="_blank"
                >
                  <i
                    className="fab fa-facebook-square foot-icon"
                    aria-hidden="true"
                  ></i>
                </a>
                <a
                  className="social-media"
                  href="https://www.instagram.com/baijnathjewellers/"
                  target="_blank"
                >
                  <i
                    className="fab fa-instagram foot-icon"
                    aria-hidden="true"
                  ></i>
                </a>
              </p>
            </div>
            <div className="footer-add2" style={{ paddingBottom: '12px' }}>
              <p style={{ padding: '0px', lineHeight: '10px' }}>
                <a href="mailto:info@baijnathjewellers.com">
                  info@baijnathjewellers.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <a href="https://whatsapp.com" target="_blank"> */}
      <a href="https://wa.me/9984500051?text=Hello" target="_blank">
        <img className="whatsApp" src={whatappIcon} alt="" />
      </a>
    </div>
  );
}

export default Footer;
